import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';

class SigninPOS extends Component {
  constructor(props) {
    super(props);

    this.state = {
      employee_num: '',
    }
  }

  componentDidMount() {
    // Change style of the wrapper so we can put a background image on
    document.getElementById("wrapper").class = "img-cover";
    document.getElementById("wrapper").style = "background-image: url(assets/img/photos-1/1.jpg); background-repeat: no-repeat; background-size: cover";
  }

  componentWillUnmount() {
    // reset the wrapper class to the original value
    document.getElementById("wrapper").class = "wrapper";
    document.getElementById("wrapper").style = '';
  }

  // What happens when you click a number button
  handleButton = number => {
    let new_employee_num = this.state.employee_num + number;
    this.setState({ employee_num: new_employee_num});
  }

  // Clear the employee number
  handleClear = () => {
    this.setState({ employee_num: ''});
  }

  // Submit the employee num to the API
  handleSubmit = () => {
    //event.preventDefault();

    // Grab the subdomain to send with login credentials to the API
    //let subdomain = window.location.host.split('.')[0];

    console.log('submitted');

    // Log user in (also send redirect and subdomain)
    //this.props.signinUser({ employee_num }, () => this.props.history.push('/pos/openorders'), subdomain);
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return (
        <div className="alert alert-danger">
          <strong>Error: </strong> {this.props.errorMessage}
        </div>
      );
    }
  }

  renderNumber() {
    if (this.state.employee_num === '') {
      return (
        <span className="h4 text-muted">Enter Employee Number</span>
      );
    } else {
      return (
        <span className="h1">&nbsp;{this.state.employee_num}</span>
      );
    }
  }

  render() {
    var style = {
      width: '50%',
      textAlign: 'center',
      marginLeft: 0,
    }

    return (
      <div className="container-fluid">
        <div className="sign-form">
          <div className="row">
            <div className="col-md-4 offset-md-4 px-3">
              <div className="box b-a-0 mb-0">
                <div className="p-2 text-xs-center">
                  <h5>DineOS Point of Sale</h5>
                </div>
                <div className="mb-1">
                  <div className="center-text mb-1">
                    {this.renderNumber()}
                  </div>
                  <div className="center-text">
                    <div className="mb-1">
                      <button type="button" onClick={event => this.handleButton(7)} className="btn btn-black btn-circle waves-effect waves-light btn-lg mr-1">7</button>
                      <button type="button" onClick={event => this.handleButton(8)} className="btn btn-black btn-circle waves-effect waves-light btn-lg mr-1">8</button>
                      <button type="button" onClick={event => this.handleButton(9)} className="btn btn-black btn-circle waves-effect waves-light btn-lg">9</button>
                    </div>
                    <div className="mb-1">
                      <button type="button" onClick={event => this.handleButton(4)} className="btn btn-black btn-circle waves-effect waves-light btn-lg mr-1">4</button>
                      <button type="button" onClick={event => this.handleButton(5)} className="btn btn-black btn-circle waves-effect waves-light btn-lg mr-1">5</button>
                      <button type="button" onClick={event => this.handleButton(6)} className="btn btn-black btn-circle waves-effect waves-light btn-lg">6</button>
                    </div>
                    <div className="mb-1">
                      <button type="button" onClick={event => this.handleButton(1)} className="btn btn-black btn-circle waves-effect waves-light btn-lg mr-1">1</button>
                      <button type="button" onClick={event => this.handleButton(2)} className="btn btn-black btn-circle waves-effect waves-light btn-lg mr-1">2</button>
                      <button type="button" onClick={event => this.handleButton(3)} className="btn btn-black btn-circle waves-effect waves-light btn-lg">3</button>
                    </div>
                    <div className="mb-1">
                      <button type="button" onClick={event => this.handleButton(0)} className="btn btn-black btn-circle waves-effect waves-light btn-lg">0</button>
                    </div>
                  </div>
                  {this.renderAlert()}
                  <div className="px-2 center-text form-group mb-0 pt-1">
                    <button onClick={event => this.handleClear()} className="btn btn-rounded btn-secondary text-uppercase mr-2">Clear</button>
                    <button onClick={event => this.handleSubmit()} className="btn btn-rounded btn-secondary text-uppercase ">Sign In</button>
                  </div>
                </div>
                <br />
                <ul className="nav nav-pills nav-fill nav-pills-color">
                  <li className="nav-item" style={style}>
                    <a className="nav-link" href="/">Dashboard</a>
                  </li>
                  <li className="nav-item" style={style}>
                    <a className="nav-link active" href="#pos">Point of Sale</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { errorMessage: state.auth.error };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SigninPOS);



// WEBPACK FOOTER //
// ./src/containers/auth/signin_pos.js